<template>
  <div class="lbv-device-view animated fadeIn roundedCard">
    <div class="lbv-heading">
      <div class="row">
        <div class="col-lg-12">
          <b-card>
            <div class="row">
              <div class="col-lg-12">
                <img
                  v-if="deviceData.isVIP === '1' && PERMISSIONS.STATIC[$store.getters.roleID].isVip"
                  class="lbv-vip"
                  src="static/img/vip.svg"
                >
                <h1 class="lbv-page-title">
                  {{ deviceData.fname }} {{ deviceData.lname }}
                </h1>
                <h4 class="lbv-partner-name">
                  {{ deviceData.tenantName }} <span class="campaignID">{{ campaignID }}</span>
                </h4>
              </div>
              <div class="col-lg-3 lbv-static-view deets">
                <!-- roleID:1 = Admin, roleID:3 = Maintenance Manager, roleID:8 = External Operations -->
                <ul
                  v-if="PERMISSIONS.STATIC[$store.getters.roleID].deviceInfo"
                  class="lbv-device-info"
                >
                  <!-- roleID:1 = Admin, roleID:8 = External Operations -->
                  <li
                    v-if="PERMISSIONS.STATIC[$store.getters.roleID].address_1"
                    class="item"
                  >
                    <i class="icon-location-pin" />
                    <span class="value">
                      {{ deviceData.address_1 | obtain({property:'address', roleID: $store.getters.roleID}) }}
                    </span>
                  </li>
                  <li
                    v-if="PERMISSIONS.STATIC[$store.getters.roleID].postcode"
                    class="item"
                  >
                    <i class="icon-location-pin" />
                    <span class="value">
                      {{ deviceData.postcode | obtain({property:'postcode', roleID: $store.getters.roleID}) }}
                    </span>
                  </li>
                  <!-- roleID:1 = Admin, roleID:8 = External Operations -->
                  <li
                    v-if="PERMISSIONS.STATIC[$store.getters.roleID].mobile_number"
                    class="item"
                  >
                    <i class="icon-screen-smartphone" />
                    <span class="value">
                      {{ deviceData.mobile_number | obtain({property:'mobile number', roleID: $store.getters.roleID}) }}
                    </span>
                  </li>
                </ul>
              </div>
              <div class="col-lg-3 lbv-static-view deets">
                <!-- roleID:1 = Admin, roleID:3 = Maintenance Manager, roleID:8 = External Operations -->
                <ul
                  v-if="PERMISSIONS.STATIC[$store.getters.roleID].customerStatus"
                  class="lbv-device-info"
                >
                  <li class="item">
                    <span class="label app-status">App Status:</span>
                    <span class="value">{{ deviceData.customerStatus | appLabel }}</span>
                  </li>
                  <li class="item">
                    <span class="label">LeakBot ID:</span>
                    <span class="value">{{ deviceData.leakbotId }}</span>
                  </li>
                  <!-- https://homeservelab.atlassian.net/browse/WAD-32 -->
                  <!-- <li class="item">
                    <span class="label">SigFox ID:</span>
                    <span class="value">{{ deviceData.deviceName }}</span>
                  </li> -->
                  <!-- roleID:1 = Admin, roleID:8 = External Operations -->
                  <li
                    v-if="PERMISSIONS.STATIC[$store.getters.roleID].serialNumber"
                    class="item"
                  >
                    <span class="label">Serial Number:</span>
                    <span class="value">{{ deviceData.serialNumber }}</span>
                  </li>
                  <li class="item">
                    <span class="label">Device Type:</span>
                    <span class="value">{{ deviceData.device_type }}</span>
                    <span class="label">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <span class="label">Firmware version:</span>
                    <span class="value">{{ deviceParameters.firmwareVersion }}</span>
                  </li>
                </ul>
              </div>
              <transition name="fade">
                <div
                  v-if="PERMISSIONS.STATIC[$store.getters.roleID].deviceStatus && statusReady"
                  class="col-lg-6 lbv-static-view"
                >
                  <ul class="lbv-status-list">
                    <li class="item">
                      <img
                        class="lbv-icon leakIcon"
                        :src="deviceData.leak_status | leakIcon"
                        alt="leak-icon"
                      >
                      <span class="status label">Low flow:</span>
                      <span
                        class="status value"
                        :title="deviceData.leak_status | leakLabel"
                      >
                        {{ deviceData.leak_status | leakLabel }}</span>
                    </li>
                    <!-- <li class="item">
                      <img
                        class="lbv-icon installationIcon"
                        :src="installStatus | customerIcon"
                        alt="installation-icon"
                      >
                      <span class="status label">Onboarding:</span>
                      <span
                        class="status value"
                        :title="installStatus"
                      >
                        {{ installStatus }}</span>
                    </li> -->
                    <li
                      v-if="analysingMode"
                      class="item"
                    >
                      <img
                        class="lbv-icon analysingIcon"
                        :src="analysingMode | analysingModeIcon"
                        alt="analysing-mode-icon"
                      >
                      <span class="status label">Analysing mode</span>
                    </li>
                    <li class="item">
                      <img
                        class="lbv-icon signalIcon"
                        :src="deviceData.message_frequency_sm | connectivityIcon"
                        alt="signal-icon"
                      >
                      <span class="status label">Connectivity:</span>
                      <span
                        class="status value"
                        :title="deviceData.message_frequency_sm | connectivityLabel"
                      >
                        {{ deviceData.message_frequency_sm | connectivityLabel }}</span>
                    </li>
                    <li class="item">
                      <img
                        class="lbv-icon batteryIcon"
                        :src="deviceData.battery_sm | batteryIcon"
                        alt="battery-icon"
                      >
                      <span class="status label">Battery:</span>
                      <span
                        class="status value"
                        :title="deviceData.battery_sm | batteryLabel"
                      >
                        {{ deviceData.battery_sm | batteryLabel }}</span>
                    </li>
                  </ul>
                </div>
              </transition>
            </div>
          </b-card>
        </div>
      </div><!--/.row-->
    </div>

    <div class="lbv-content">
      <div class="row">
        <div class="col-lg-12 lbv-tabs-device">
          <b-tabs
            pills
            @input="tabSwitchHandler"
          >
            <b-tab
              v-if="PERMISSIONS.TAB[$store.getters.roleID].profile"
              title="Profile"
              active
            >
              <ProfileView :device-data="deviceData" />
            </b-tab>
            <!-- roleID:1 = Admin, roleID:8 = External Operations -->
            <b-tab
              v-if="PERMISSIONS.TAB[$store.getters.roleID].contact_notes"
              title="Contact Notes"
            >
              <ContactNotes :lb_id="deviceData.lb_id" />
            </b-tab>
            <b-tab
              v-if="PERMISSIONS.TAB[$store.getters.roleID].events"
              title="Events"
            >
              <DeviceEventView :lb_id="deviceData.lb_id" />
            </b-tab>
            <!-- roleID:1 = Admin -->
            <b-tab
              v-if="PERMISSIONS.TAB[$store.getters.roleID].deviceData"
              title="Device Data"
            >
              <DeviceDataView
                :lb_id="deviceData.lb_id"
                :device_id="deviceData.leakbotId"
              />
            </b-tab>
            <b-tab
              v-if="PERMISSIONS.TAB[$store.getters.roleID].commsHistory"
              title="Comms History"
            >
              <CommsHistoryView :lb_id="deviceData.lb_id" />
            </b-tab>
            <!-- roleID:1 = Admin, roleID:8 = External Operations -->
            <b-tab
              v-if="PERMISSIONS.TAB[$store.getters.roleID].engBooking"
              title="Eng Repair"
            >
              <EngineerBookingView
                :lb_id="deviceData.lb_id"
                :leak-status="deviceData.leak_status"
                :leakbot-id="deviceData.leakbotId"
              />
            </b-tab>
            <!-- roleID:1 = Admin, roleID:5 = Super Admin -->
            <b-tab
              v-if="PERMISSIONS.TAB[$store.getters.roleID].admin"
              title="Admin"
            >
              <AdminView
                :lb_id="deviceData.lb_id"
                :high-usage-only="highUsageOnly"
                :header-tank-checkbox="headerTankCheckbox"
                :underfloor-heating-checkbox="underfloorHeatingCheckbox"
                :cold-void-checkbox="coldVoidCheckbox"
                :unknown-checkbox="unknownCheckbox"
              />
            </b-tab>
            <!-- roleID:1 = Admin -->
            <b-tab
              v-if="PERMISSIONS.TAB[$store.getters.roleID].leakFree"
              title="Leak-Free Days"
            >
              <LeakFreeView />
            </b-tab>
          </b-tabs>
        </div>
      </div><!--/.row-->
    </div>
  </div><!--/.lbv-device-view -->
</template>

<script>
import deviceViewMixin from '../mixins/deviceViewMixin'
import { PERMISSIONS } from '../constants/permissions/permissions'

export default {
  name: 'DeviceView',
  mixins: [deviceViewMixin],
  props: ['deviceID'],
  data () {
    return {
      PERMISSIONS
    }
  }
}
</script>
<style>
  .lbv-status-list .item {
    white-space: nowrap;
  }

  .lbv-status-list .item img{
    width: 40px;
    height: 40px;
  }

  span.status.value {
    white-space: normal;
  }

  .label.app-status {
    color: #FC5969;
  }

  .campaignID {
    font-size: 12px;
  }
</style>
